import { useMemo } from 'react';

import { useMatches } from '@tanstack/react-router';

import { type Breadcrumb, BreadcrumbContext } from './useBreadcrumbs';

interface Props {
	children: React.ReactNode;
}

export function BreadcrumbProvider({ children }: Props) {
	const matches = useMatches();

	const breadcrumbs = useMemo(
		() =>
			matches
				.filter(
					({ context }) => typeof context.getTitle === 'string' && context.getTitle !== undefined
				)
				.reduce(
					(acc, { pathname, context }) => [
						...acc,
						{
							title: context.getTitle,
							path: pathname
						} as Breadcrumb
					],
					[] as Breadcrumb[]
				),
		[matches]
	);

	return (
		<BreadcrumbContext.Provider value={{ breadcrumbs }}>{children}</BreadcrumbContext.Provider>
	);
}
